import { render, staticRenderFns } from "./UploadNewFile.vue?vue&type=template&id=7353bf91&scoped=true&"
import script from "./UploadNewFile.vue?vue&type=script&lang=js&"
export * from "./UploadNewFile.vue?vue&type=script&lang=js&"
import style0 from "./UploadNewFile.vue?vue&type=style&index=0&id=7353bf91&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7353bf91",
  null
  
)

export default component.exports